import ContractCodesPage from "./contractCodes";

export default ContractCodesPage;

